@switch ($definition().componentClass) {
    @case ("rgbCurve") {
        <cm-rgb-curve-widget [material]="$material()"></cm-rgb-curve-widget>
    }
    @case ("imageTextureSet") {
        <cm-image-texture-set-widget
            [material]="$material()"
            [materialId]="$materialId()"
            [materialRevisionId]="$materialRevisionId()"
        ></cm-image-texture-set-widget>
    }
    @case ("textureRevision") {
        <cm-texture-revision-widget
            [material]="$material()"
            [materialId]="$materialId()"
            [materialRevisionId]="$materialRevisionId()"
        ></cm-texture-revision-widget>
    }
    @case ("textureFromSet") {
        <cm-texture-from-set-widget
            [material]="$material()"
            [materialId]="$materialId()"
            [materialRevisionId]="$materialRevisionId()"
        ></cm-texture-from-set-widget>
    }
    @case ("colorRamp") {
        <cm-color-ramp-widget [material]="$material()"></cm-color-ramp-widget>
    }
    @default {
        <p>Custom component {{ $definition().componentClass }} not implemented!</p>
    }
}
